<template>
  <div class="macro_right">
    <p class="company_common_title">
      <span>Macro index search</span>
    </p>

    <!-- search result -->
    <div class="downContainer">
      <title-temp title="Search results"></title-temp>
      <table-list :column="currentColumn" :tableData="currentData" :column200="true"></table-list>
    </div>

    <!-- Chart display -->
    <div class="chart-contai">
      <title-temp title="Chart display"></title-temp>
      <line-chart :xData="xData" :serData="serData"></line-chart>
    </div>
  </div>
</template>

<script>
import TitleTemp from "common/components/Title";
import { getMacroCommon } from "common/js/http/v2Api";
import column from "conf/macroColumn";
import TableList from "common/components/table";
import LineChart from "../../BarLine";

const color = [
  "#836FFF",
  "#71C671",
  "#5E71FF",
  "#86C1FF",
  "#7583EA",
  "#FFC962",
  "#BCD2EE",
  "#A2B5CD",
  "#FFC125",
  "#757575"
];

export default {
  components: {
    TitleTemp,
    TableList,
    LineChart
  },

  props: ["conditions"],

  data() {
    return {
      currentColumn: column,
      currentData: [],
      xData: [],
      serData: [],
      worker: null,
      userId:parseInt(this.Cookies.get("imsilkroad_userid")),
      userName: this.Cookies.get("imsilkroad_username"),
    };
  },

  created() {
    this.searchResult(this.conditions);
  },

  methods: {
    //当前时间 5年
    getDateChart() {
      return {
        start: this.$moment(new Date())
          .subtract(5, "years")
          .format("YYYY-MM-DD"),
        end: this.$moment(new Date()).format("YYYY-MM-DD")
      };
    },

    async searchResult(conditions) {
      const params = {
        api: "/api/queryIndictorData.html",
        methodType: "POST",
        params: {
          type: "EN_CEIC",
          basicNameArray: [conditions.name],
          countryArray: [conditions.countryName],
          rate: "",
          start: this.getDateChart().start,
          end: this.getDateChart().end
        },
        userId: this.userId,
        userName: this.userName
      };
      const { result } = await getMacroCommon(params);
      this.converTableData(result);

      this.converChartData(result);
    },

    converTableData(result) {
      const data = result.data;
      if (!data.length) return;
      const columnCf = this.$lodash.cloneDeep(column);
      const result1 = data.map(item => {
        result.columns.forEach(j => {
          if (j.isDate) {
            columnCf.push({
              label: j.title,
              field: j.field
            });
          }
        });
        // return itemData;
      });
      // 设置列
      this.currentColumn = columnCf;
      this.currentData = result.data;
    },

    converChartData(result) {
      const data = this.$lodash.cloneDeep(result.data);

      const result1 = data.map((item, index) => {
        const x_data = [];
        let countryName = item.country_cn_simplename
          ? ":" + item.country_cn_simplename
          : "";
        const itemData = {
          name: item.cn_name + countryName,
          type: "line",
          // stack: "dta",
          data: [],
          unit: item.unit_cn_description,
          smooth: true,
          itemStyle: {
            normal: {
              color: color[index % 10], //改变折线点的颜色
              lineStyle: {
                color: color[index % 10] //改变折线颜色
              }
            }
          }
        };
        result.columns.forEach(j => {
          if (j.isDate) {
            x_data.push(j.title);
            itemData.data.push(parseInt(item[j.field]));
          }
        });
        // Object.keys(item).forEach(j => {
        //   if (j.includes("_status")) {
        //     const key = j.split("_")[0];
        //     x_data.push(key);
        //     itemData[key] = item[key];
        //     itemData.data.push(item[key] || 0);
        //   }
        // });
        itemData.data = itemData.data.reverse();
        this.xData = x_data.reverse();
        return itemData;
      });
      this.serData = result1;
    }
  }
};
</script>
<style scoped>
.macro_right {
  height: 100%;
  padding: 20px;
}
.btnContainer {
  text-align: right;
  margin-top: 20px;
}
.list-item {
  border: 1px solid #f3f4f5;
  height: 100px;
  margin-bottom: 20px;
}
.list-item div {
  display: inline-block;
  overflow: auto;
  height: 100%;
}
.item-title {
  background: #f8f9fa;
  border-right: 1px solid #0078ff;
  height: 100%;
  width: 200px;
  padding: 40px 0px 0px 20px;
  font-size: 17px;
  font-weight: 600;
}
.list-content {
  width: calc(100% - 200px);
  word-wrap: break-word;
  word-break: normal;
  vertical-align: top;
  padding: 10px;
}
.tag_list span {
  border: 1px solid #e2e3e4;
  border-radius: 15.5px;
  /* padding: 5px 10px; */
  margin-right: 10px;
  margin-bottom: 10px;
}
.downContainer {
  position: relative;
}
.downLoadBtn {
  position: absolute;
  right: 0px;
}
.chart-contai >>> .el-date-editor .el-range-separator {
  line-height: 25px;
}
.chart-contai >>> .el-date-editor .el-range__close-icon {
  line-height: 27px;
}
</style>